import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { List, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import StyledNavListItem from './StyledNavListItem';

const PortalNavList = ({ items, onNavigate }) => {
  const location = useLocation();
  const isPathActive = (path) => location.pathname.startsWith(path);

  return (
    <List disablePadding>
      {items.map(({ label, path, icon: Icon, disabled = false }) => {
        const item = (
          <StyledNavListItem
            key={path}
            button={!disabled}
            component={disabled ? 'div' : Link}
            to={disabled ? undefined : path}
            isActive={!disabled && isPathActive(path)}
            disabled={disabled}
            aria-disabled={disabled || undefined}
            onClick={disabled ? undefined : onNavigate}
            sx={
              disabled
                ? {
                    opacity: 0.45,
                    cursor: 'not-allowed',
                    pointerEvents: 'none',
                    '&:hover': { backgroundColor: 'transparent' },
                  }
                : undefined
            }
          >
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemText primary={label} />
          </StyledNavListItem>
        );

        if (!disabled) return item;

        return (
          <Tooltip key={path} title="Complete your subscription to unlock" placement="right">
            <span>{item}</span>
          </Tooltip>
        );
      })}
    </List>
  );
};

export default PortalNavList;
